import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales/i18n'
import { 
  ElMessage, 
  ElLoading, 
  ElDropdown, 
  ElDropdownMenu, 
  ElDropdownItem, 
  ElInputNumber,
  ElSelect,  
  ElOption, 
  ElSkeleton,
  ElSkeletonItem,
  ElScrollbar, 
  ElPagination, 
  ElDialog, 
  ElInput, 
  ElDrawer, 
  ElOptionGroup
} from 'element-plus'
import 'element-plus/dist/index.css'
import '@/style/index.css'
// import ElementPlus from 'element-plus';


const app = createApp(App);
const head = createHead()
app.use(head)
app.use(i18n)
app.use(router)
app.use(store)

app.component(ElDropdown.name, ElDropdown)
app.component(ElDropdownMenu.name, ElDropdownMenu)
app.component(ElDropdownItem.name, ElDropdownItem)
app.component(ElDialog.name, ElDialog)
app.component(ElOption.name, ElOption)
app.component(ElOptionGroup.name, ElOptionGroup)
app.component(ElSelect.name, ElSelect)
app.component(ElInput.name, ElInput)
app.component(ElDropdown.name, ElDropdown)
app.component(ElScrollbar.name, ElScrollbar)
app.component(ElPagination.name, ElPagination)
app.component(ElInputNumber.name, ElInputNumber)
app.component(ElSkeleton.name, ElSkeleton)
app.component(ElSkeletonItem.name, ElSkeletonItem)
app.component(ElDrawer.name, ElDrawer)
// app.use(ElementPlus);
app.provide('$loading', ElLoading)
app.provide('$message', ElMessage)
app.mount('#app')

app.directive('animate', {
  mounted: function (el, binding) {
    // 防抖函数实现
    const debounce = (func, wait) => {
      let timeout
      return function() {
        const context = this
        const args = arguments
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          func.apply(context, args)
        }, wait)
      }
    }

    // 滚动处理函数
    const scrollHandler = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight
      
      if (top < h) {
        if (!el.classList.contains(binding.value.class)) {
          setTimeout(() => {
            el.classList.remove('animation_hide')
          }, binding.value.delay)
          el.classList.add(binding.value.class)
        }
        window.removeEventListener('scroll', binding.debouncedHandler)
      }
    }

    // 创建防抖版本
    binding.debouncedHandler = debounce(scrollHandler, 100)

    // 添加事件监听
    window.addEventListener('scroll', binding.debouncedHandler)
    // 初始检查
    scrollHandler()
  },
  beforeUnmount: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})